import UZod from "@repo/utils/UZod";
import Bookable from "./Bookable.js";
import Recurrence from "./Recurrence.js";
import Staff from "./Staff.js";
import Address from "@repo/utils/Address";
import UObject from "@repo/utils/UObject";

type Organization = {
  id: Organization.Id;
  name: string;
  imgUrl: string;
  email: string;
  phoneNumber?: string;
  websiteUrl?: string;
  address: Address;
  descriptionMd?: string;
};

namespace Organization {
  export type Id = `o_${string}`;
  export namespace Id {
    export const is = (id: unknown): id is Id =>
      typeof id === "string" && id?.startsWith("o_");
    export const zodSchema = (message = "Invalid organization id.") =>
      UZod.predicate(is, message);
  }
  export type Params = Pick<
    Organization,
    "name" | "email" | "phoneNumber" | "websiteUrl" | "descriptionMd"
  > & {
    imgBase64: string;
    imgMimeType: string;
  };

  export type Schedule = {
    bookables: Bookable[];
    recurrences: Recurrence[];
    staffs: Staff[];
    bookableTemplates: Bookable.Template[];
  };
  export namespace Schedule {
    export type WithSupplements = Organization.Schedule & {
      bookableSupplements?: Bookable.AdminSupplement[];
      bookableTemplateSupplements?: Bookable.Template.AdminSupplement[];
    };
  }

  export type TaxSettings = {
    bookingTaxRate: number;
    membershipTaxRate: number;
    productTaxRate: number;
  };

  export type FromApi = UObject.Override<
    Organization,
    {
      address: Address.Us;
    }
  >;

  export const normalize = (
    organization: Organization.FromApi | Organization,
  ): Organization => ({
    ...organization,
    // Address actually comes in as Address.Us
    address: Address.normalize(organization.address),
    imgUrl: organization.imgUrl || "/yoga-pfp.jpeg",
  });
}

export default Organization;
